module.exports = __webpack_public_path__ + "img/menuhelper.e582a273.svg";